<div>
    <form [formGroup]="baseFormGroup" #f="ngForm" class="">
        <div *ngIf="varConfig.showIDs" style="background-color: yellow;">
            #{{fc.ID.value}}
        </div>
        <div class="row" *ngIf="izlazna">
            <!-- Redni broj-->
            <div class="col-lg-1">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICASTAVKA.REDNIBROJ.SINGULAR'"
                            formControlName="RedniBroj"
                            [ngClass]="{'is-invalid': submitted && fc.RedniBroj.invalid}"
                            [MaxLength]="13"
                            [disabled]="true"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.RedniBroj.invalid">
                            <span *ngFor="let validation of errorMessages.RedniBroj">
                                <span class="erro r-message" *ngIf="fc.RedniBroj.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>            
            <div class="col-lg-3">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-dropdown-picklist
                            #autofocus
                            [ModelName]="'roba'"
                            [GetName]="'get'"
                            [ModelProperty]="'Sifra,Naziv,UnitOfMeasure'"
                            [OrderBy]="'Naziv'"
                            [AllowAddNew]="true"
                            [AllowEdit]="true"
                            formControlName="RobaID"
                            [Label]="'EOTPREMNICASTAVKA.ROBA.SINGULAR'"
                            [Width]="'xl'" [Position]="'left'"
                            (OnItemSelected)="onRobaSelect($event)"
                            (GetItems)="RobaGetItems($event)"
                        >
                        </yt-dropdown-picklist>
                        <div class="form-error" *ngIf="submitted && fc.RobaID.invalid">
                            <span *ngFor="let validation of errorMessages.RobaID">
                                <span class="error-message" *ngIf="fc.RobaID.hasError(validation.type)">
                                    <span translate="{{validation.message}}"></span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtKolicina"
                            [Label]="'EOTPREMNICASTAVKA.KOLICINA.SINGULAR'"
                            formControlName="Kolicina">
                        </yt-number-input-v3>
                        <div class="form-error" *ngIf="submitted && fc.Kolicina.invalid">
                            <span *ngFor="let validation of errorMessages.Kolicina">
                                <span class="error-message" *ngIf="fc.Kolicina.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                        <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                            <span class="error-message"
                                *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlKolicina && !this.baseFormGroup.errors.checkControlKolicina.valid"><span
                                    translate="{{this.baseFormGroup.errors.checkControlKolicina.message}}"></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="col-lg-1 col-12">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-dropdown-picklist [ModelName]="'jedinicamere'" [GetName]="'get'" [ModelProperty]="'Oznaka'"
                            [OrderBy]="'Naziv'" [AllowAddNew]="false" formControlName="JedinicaMereID"
                            [Label]="'EOTPREMNICASTAVKA.JM.SINGULAR'" [Width]="'600px'"
                            [ngClass]="{'is-invalid': submitted && fc.JedinicaMereID.invalid}">
                        </yt-dropdown-picklist>
                        <div class="form-error" *ngIf="submitted && fc.JedinicaMereID.invalid">
                            <span *ngFor="let validation of errorMessages.JedinicaMereID">
                                <span class="error-message" *ngIf="fc.JedinicaMereID.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- Akcizna roba - tip pakovanja (duvan i dr.) -->
            <div class="col-lg-2 col-12" *ngIf="trebaTipPakovanjaDDL">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-dropdown-picklist
                            [ModelName]="'akciznarobatippakovanja'"
                            [GetName]="'GetByAkciznaRobaId'"
                            [GetParameters]="parameterListZaKategoriju"
                            [ModelProperty]="'Naziv'"
                            [OrderBy]="'Naziv'"
                            [AllowAddNew]="false"
                            formControlName="AkciznaRobaTipPakovanjaID"
                            [Label]="'EOTPREMNICASTAVKA.AKCIZNAROBATIPPAKOVANJA.SINGULAR'"
                            [Width]="'600px'"
                            [ngClass]="{'is-invalid': submitted && fc.AkciznaRobaTipPakovanjaID.invalid}"
                            (OnItemSelected)="onTipPakovanjaSelect($event)"
                            [disabled]="baseFormGroup.get('AkciznaRobaTipPakovanjaID')?.disabled"

                            (GetItems)="AkciznaRobaTipPakovanjaGetItems($event)"
                        >
                        </yt-dropdown-picklist>
                        <div class="form-error" *ngIf="submitted && fc.AkciznaRobaTipPakovanjaID.invalid">
                            <span *ngFor="let validation of errorMessages.AkciznaRobaTipPakovanjaID">
                                <span class="error-message"
                                    *ngIf="fc.AkciznaRobaTipPakovanjaID.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Akcizna roba - tip pakovanja -->
            <div class="col-lg-2 col-12" *ngIf="!trebaTipPakovanjaDDL">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICASTAVKA.AKCIZNAROBATIPPAKOVANJA.SINGULAR'"
                            formControlName="AkciznaRobaTipPakovanja"
                            [ngClass]="{'is-invalid': submitted && fc.AkciznaRobaTipPakovanja.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.AkciznaRobaTipPakovanja.invalid">
                            <span *ngFor="let validation of errorMessages.AkciznaRobaTipPakovanja">
                                <span class="error-message" *ngIf="fc.AkciznaRobaTipPakovanja.hasError(validation.type)">
                                    <span translate="{{validation.message}}"></span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div> 

            <!-- Akcizna roba - tip pakovanja (duvan) - vrednost -->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtAkciznaRobaTipPakovanjaVrednost"
                            [Label]="'EOTPREMNICASTAVKA.AKCIZNAROBATIPPAKOVANJAVREDNOST.SINGULAR'"
                            formControlName="AkciznaRobaTipPakovanjaVrednost"
                            [disabled]="baseFormGroup.get('AkciznaRobaTipPakovanjaVrednost')?.disabled"

                        >
                        </yt-number-input-v3>
                        <div class="form-error" *ngIf="submitted && fc.AkciznaRobaTipPakovanjaVrednost.invalid">
                            <span *ngFor="let validation of errorMessages.AkciznaRobaTipPakovanjaVrednost">
                                <span class="error-message"
                                    *ngIf="fc.AkciznaRobaTipPakovanjaVrednost.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                        <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                            <span class="error-message"
                                *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlAkciznaRobaTipPakovanjaVrednost && !this.baseFormGroup.errors.checkControlAkciznaRobaTipPakovanjaVrednost.valid"><span
                                    translate="{{this.baseFormGroup.errors.checkControlAkciznaRobaTipPakovanjaVrednost.message}}"></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Akcizna roba - šifra marke -->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICASTAVKA.AKCIZNAROBASIFRAROBNEMARKE.SINGULAR'"
                            formControlName="AkciznaRobaSifraRobneMarke"
                            [ngClass]="{'is-invalid': submitted && fc.AkciznaRobaSifraRobneMarke.invalid}"
                            [disabled]="baseFormGroup.get('AkciznaRobaSifraRobneMarke')?.disabled"
                            [MaxLength]="50"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.AkciznaRobaSifraRobneMarke.invalid">
                            <span *ngFor="let validation of errorMessages.AkciznaRobaSifraRobneMarke">
                                <span class="error-message" *ngIf="fc.AkciznaRobaSifraRobneMarke.hasError(validation.type)">
                                    <span translate="{{validation.message}}"></span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>  
            <!-- Jedinica mere -->
            <!-- <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICASTAVKA.JEDINICAMERENAZIV.SINGULAR'"
                            formControlName="JedinicaMereNaziv"
                            [ngClass]="{
                            'is-invalid': submitted && fc.JedinicaMere.invalid
                            }"
                            [MaxLength]="50"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.JedinicaMere.invalid">
                            <span *ngFor="let validation of errorMessages.JedinicaMere">
                                <span class="error-message" *ngIf="fc.JedinicaMere.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>

        <div class="row" *ngIf="!izlazna || razvoj">
        <!-- <div class="row" > -->
            <!-- Redni broj-->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICASTAVKA.REDNIBROJ.SINGULAR'"
                            formControlName="RedniBroj"
                            [ngClass]="{'is-invalid': submitted && fc.RedniBroj.invalid}"
                            [MaxLength]="13"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.RedniBroj.invalid">
                            <span *ngFor="let validation of errorMessages.RedniBroj">
                                <span class="erro r-message" *ngIf="fc.RedniBroj.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Sifra robe -->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICASTAVKA.SIFRA.SINGULAR'"
                            formControlName="Sifra"
                            [ngClass]="{'is-invalid': submitted && fc.Sifra.invalid}"
                            [MaxLength]="13"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.Sifra.invalid">
                            <span *ngFor="let validation of errorMessages.Sifra">
                                <span class="error-message" *ngIf="fc.Sifra.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Naziv robe -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICASTAVKA.NAZIV.SINGULAR'"
                            formControlName="Naziv"
                            [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                            [MaxLength]="200"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                            <span *ngFor="let validation of errorMessages.Naziv">
                                <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Količina robe -->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtKolicina"
                            [Label]="'EOTPREMNICASTAVKA.KOLICINA.SINGULAR'"
                            formControlName="Kolicina"
                        >
                        </yt-number-input-v3>
                        <div class="form-error" *ngIf="submitted && fc.Kolicina.invalid">
                            <span *ngFor="let validation of errorMessages.Kolicina">
                                <span class="error-message" *ngIf="fc.Kolicina.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                        <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                            <span class="error-message"
                                *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlKolicina && !this.baseFormGroup.errors.checkControlKolicina.valid"><span
                                    translate="{{this.baseFormGroup.errors.checkControlKolicina.message}}"></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Šifra jedinica mere -->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICASTAVKA.JEDINICAMERE.SINGULAR'"
                            formControlName="JedinicaMere"
                            [ngClass]="{'is-invalid': submitted && fc.JedinicaMere.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.JedinicaMere.invalid">
                            <span *ngFor="let validation of errorMessages.JedinicaMere">
                                <span class="error-message" *ngIf="fc.JedinicaMere.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="row" *ngIf="!izlazna || razvoj">
        <!-- <div class="row"> -->
            <!-- Akcizna roba - kategorija -->
            <div class="col-lg-3">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICASTAVKA.AKCIZNAROBA.SINGULAR'"
                            formControlName="AkciznaRoba"
                            [ngClass]="{'is-invalid': submitted && fc.AkciznaRoba.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.AkciznaRoba.invalid">
                            <span *ngFor="let validation of errorMessages.AkciznaRoba">
                                <span class="error-message" *ngIf="fc.AkciznaRoba.hasError(validation.type)">
                                    <span translate="{{validation.message}}"></span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Akcizna roba - tip pakovanja -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICASTAVKA.AKCIZNAROBATIPPAKOVANJA.SINGULAR'"
                            formControlName="AkciznaRobaTipPakovanja"
                            [ngClass]="{'is-invalid': submitted && fc.AkciznaRobaTipPakovanja.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.AkciznaRobaTipPakovanja.invalid">
                            <span *ngFor="let validation of errorMessages.AkciznaRobaTipPakovanja">
                                <span class="error-message" *ngIf="fc.AkciznaRobaTipPakovanja.hasError(validation.type)">
                                    <span translate="{{validation.message}}"></span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>        
            <!-- Akcizna roba - tip pakovanja vrednost -->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            #tipPakovanjaVrednost2
                            name="txtAkciznaRobaTipPakovanjaVrednost1"
                            [Label]="'EOTPREMNICASTAVKA.AKCIZNAROBATIPPAKOVANJAVREDNOST.SINGULAR'"
                            formControlName="AkciznaRobaTipPakovanjaVrednost"
                            [disabled]="baseFormGroup.get('AkciznaRobaTipPakovanjaVrednost')?.disabled"
                        >
                        </yt-number-input-v3>
                        <div class="form-error" *ngIf="submitted && fc.AkciznaRobaTipPakovanjaVrednost.invalid">
                            <span *ngFor="let validation of errorMessages.AkciznaRobaTipPakovanjaVrednost">
                                <span class="error-message"
                                    *ngIf="fc.AkciznaRobaTipPakovanjaVrednost.hasError(validation.type)"><span
                                        translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                        <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                            <span class="error-message"
                                *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControlAkciznaRobaTipPakovanjaVrednost && !this.baseFormGroup.errors.checkControlAkciznaRobaTipPakovanjaVrednost.valid"><span
                                    translate="{{this.baseFormGroup.errors.checkControlAkciznaRobaTipPakovanjaVrednost.message}}"></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>              
            <!-- Akcizna roba - šifra marke -->
            <div class="col-lg-3">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICASTAVKA.AKCIZNAROBASIFRAROBNEMARKE.SINGULAR'"
                            formControlName="AkciznaRobaSifraRobneMarke"
                            [ngClass]="{'is-invalid': submitted && fc.AkciznaRobaSifraRobneMarke.invalid}"
                            [disabled]="baseFormGroup.get('AkciznaRobaSifraRobneMarke')?.disabled"

                            [MaxLength]="50"
                        >
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.AkciznaRobaSifraRobneMarke.invalid">
                            <span *ngFor="let validation of errorMessages.AkciznaRobaSifraRobneMarke">
                                <span class="error-message" *ngIf="fc.AkciznaRobaSifraRobneMarke.hasError(validation.type)">
                                    <span translate="{{validation.message}}"></span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>              
        </div>
        <div class="row">
            <div class="col-md-12">
                <label class="toggle">
                    <input
                        #toggleDodatniAtributiCheckbox
                        class="toggle-checkbox"
                        type="checkbox"
                        [(ngModel)]="showDodatniAtributi"
                        [ngModelOptions]="{standalone: true}"
                        (change)="onToggleDodatniAtributi()"                      
                    >
                    <!-- [disabled]="!izlazna" -->

                    <div class="toggle-switch"></div>

                    <span class="toggle-label">{{ 'EOTPREMNICASTAVKA.DODATNIATRIBUTI.TOGGLE' | translate }}</span>

                    <!-- badge: prikazuje broj unetih atributa kada je skriveno -->
                    <span *ngIf="!showDodatniAtributi && Item?.BrojDodatnihAtributa > 0"
                        class="badge badge-info ml-2">
                        {{ Item.BrojDodatnihAtributa }} uneto
                    </span>
                </label>

                <!-- <div class="btn-group float-right" *ngIf="izlazna"> -->
                <!-- <div class="btn-group float-right" *ngIf="izlazna">
                    <button type="button" class="btn btn-outline-primary" (click)="Save()" [disabled]="saveDisabled"><span class="fa fa-fa fa-save"></span> Sačuvaj</button>
                    <button type="button" class="btn btn-outline-primary" (click)="Reset()"><span class="fa fa-fa fa-undo"></span> Odustani</button>
                </div> -->
            </div>
        </div>

        <!-- Dodatni atributi -->
        <div class="row" *ngIf="showDodatniAtributi">
            <div class="col-md-12">
                <yt-eotpremnica-stavka-dodatni-atribut-update-container
                    #nestedInlineContainer
                    [DetailModelData]="modelData.MainList.DetailList[3]"
                    [ParentPropertyName]="'EOtpremnicaStavkaID'"
                    [ParentPropertyValue]="Item?.ID"
                    [NestedInline]="true"
                    [Level]="'attribute'"
                    [Parameters]="TransferParameters"
                    [Disabled]="Item?.Editable != null && !Item?.Editable"
                >
                </yt-eotpremnica-stavka-dodatni-atribut-update-container>
            </div>
        </div>
    </form>
</div>
